import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { SessionBank } from '../../types/session';
import { initSessionSuccess } from '../actions/session.actions';

const initialState: Partial<SessionBank> = {};

export const bankSlice = createSlice({
	name: 'session/bank',
	initialState,
	reducers: {
		saveSessionBank(state, action: PayloadAction<Partial<SessionBank>>) {
			const bank = action.payload;
			return { ...state, ...bank };
		}
	},
	extraReducers: (builder) => {
		builder.addCase(initSessionSuccess, (bankState, action) => {
			const session = action.payload;
			const bank = session.bank;
			if (bank)
				return {
					...bank
				};
		});
	}
});

export const selectSessionBankName = (state: RootState) => state.bank.bankName;
export const selectSessionBankCode = (state: RootState) => state.bank.bankCode;
export const selectSessionCountryCode = (state: RootState) => state.bank.countryCode;

export const { saveSessionBank } = bankSlice.actions;
